import React from 'react';
import i18next from 'i18next';
import apiForm from './apiForm';
import OperationsHistory from '../OperationsHistory/OperationsHistory';

class OperationsForm extends React.PureComponent {
  render() {
    return (
      <div className="operations-form">
        <span className="form__title form__title--secondary">
          {i18next.t('operations_form.title')}
        </span>
        <OperationsHistory defaultTab={this.props.defaultTab} />
      </div>
    );
  }
}

export default apiForm(OperationsForm);



// WEBPACK FOOTER //
// ./app/components/Form/OperationsForm.jsx